/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs */

const en_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background removal and upscaling`)
};

const ar_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة الخلفيات وتحسين الدقة`)
};

const bn_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকগ্রাউন্ড সরানো ও আপস্কেলিং`)
};

const de_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundentfernung und Hochskalierung`)
};

const es_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminación de fondos y mejora de resolución`)
};

const fr_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détourage et montée en résolution`)
};

const pt_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de fundos e aumento de resolução`)
};

const zh_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抠图与超分`)
};

const tr_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arka plan temizliği ve büyütme`)
};

const ru_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление фона и апскейл`)
};

const pl_svc_ai_image_pod_automation_cleanup_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycinanie tła i upscaling`)
};

/**
* | output |
* | --- |
* | "Background removal and upscaling" |
*
* @param {Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_cleanup_title7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Cleanup_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_cleanup_title7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_cleanup_title7(inputs)
	return en_svc_ai_image_pod_automation_cleanup_title7(inputs)
});
export { svc_ai_image_pod_automation_cleanup_title7 as "svc_ai-image-pod-automation_CLEANUP_title" }